import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { Form } from './components/Form';
import { Form as AnispiForm } from './components/anispi-form/Form';

const App = () => {
  const router = createBrowserRouter([
    {
      element: <Form />,
      errorElement: <p>404 Not Found.</p>,
      path: '/',
    },
    {
      element: <AnispiForm />,
      path: '/anispi-form/',
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
      <footer className="w-full py-2 text-center">©️ANISPI HOLDINGS Inc.</footer>
    </>
  );
};

export default App;
